/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as TermsAndConditions from './trans-website-comai-termsandconditions';
export * as Feedback from './trans-website-comai-feedback';

export const AiName = 'Website.ComAi.AiName';
export const ClearHistory = 'Website.ComAi.ClearHistory';
export const Disclaimer = 'Website.ComAi.Disclaimer';
export const InputPlaceholder = 'Website.ComAi.InputPlaceholder';
export const MessageError = 'Website.ComAi.MessageError';
export const AskMoreAboutProduct = 'Website.ComAi.AskMoreAboutProduct';
export const AskMoreAboutProductDropdown = 'Website.ComAi.AskMoreAboutProductDropdown';
export const AskAbout = 'Website.ComAi.AskAbout';
export const NoneOfTheAbove = 'Website.ComAi.NoneOfTheAbove';
export const ProblemSolverSubmit = 'Website.ComAi.ProblemSolverSubmit';
export const QuestionAbout = 'Website.ComAi.QuestionAbout';
